module.exports = __webpack_public_path__ + "static/media/id-success.2332360e.svg";